function Footer() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: 15,
        background: "linear-gradient(135deg, #4d26da, #2196F3) ",
        color: "white",
        marginTop: 20,
      }}
    >
      <p>© 2026 Family Budget Planner | Built with React</p>
    </div>
  );
}
export default Footer;
